export default "__VITE_ASSET__DCrVXW1G__"